import { arrayOfAllUnique } from '../utils/listUtils.ts'

export const ConfigurableServers = [
  'collCalc',
  'life',
  'unitLink',
  'legalEntity',
  'moneyIn',
  'moneyOut',
] as const

export const ServersWithTestService = [
  ...ConfigurableServers,
  'lifeDataReplicator',
  'unitLinkDataReplicator',
  'legalEntityDataReplicator',
  'dataMart',
  'dataMart2',
] as const

export const ServersWithoutReplicators =
  arrayOfAllUnique<ServerWithTestWithoutReplicators>()([
    'collCalc',
    'life',
    'unitLink',
    'legalEntity',
    'moneyIn',
    'moneyOut',
    'dataMart',
    'dataMart2',
  ])

export const AllServers = [...ServersWithTestService, 'configuration'] as const

export type ConfigurableServer = (typeof ConfigurableServers)[number]
export type ServerWithTest = (typeof ServersWithTestService)[number]
export type ServerWithTestWithoutReplicators = Exclude<
  ServerWithTest,
  `${string}DataReplicator`
>
export type Server = (typeof AllServers)[number]
export type ServerSubset<TServer extends Server> = TServer
export type ServerWithoutReplicators = Exclude<
  Server,
  `${string}DataReplicator`
>

export const isServer = (server: string): server is Server =>
  (AllServers as readonly string[]).includes(server)

export const isConfigurableServer = (
  server: string,
): server is ConfigurableServer =>
  (ConfigurableServers as readonly string[]).includes(server)

export const isServerWithTest = (server: string): server is ServerWithTest =>
  (ServersWithTestService as readonly string[]).includes(server)

export type Countries = 'dk' | 'nl' | 'uk'
export type GeneralAndCountries = Countries | 'general'
